import { ref } from 'vue';
import { Router, useRouter } from 'vue-router';
export const flag1 = ref(false);
function getUrlArrayFromSession() {
    const urlArrayString = sessionStorage.getItem('urlArray');
    return urlArrayString ? JSON.parse(urlArrayString) : [];
}
function setUrlArrayToSession(urlArray) {
    sessionStorage.setItem('urlArray', JSON.stringify(urlArray));
     const urlArrayString = sessionStorage.getItem('urlArray');
}
function extractPathFromUrl(url) {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.hash ? parsedUrl.hash.slice(1) : parsedUrl.pathname;
    } catch (error) {
        // console.error('Invalid URL:', url);
        return url;
    }
}
const findStoretabDetails = (arr: string[]): string | undefined => {
    for(let i = arr.length-1 ; i>=0; i--){
         if(arr[i].includes('StoreTabDetails')){
            return arr[i];
        }
    }
  return arr.find(element => element.includes('StoreTabDetails'));
};
export function setupHistoryManagement(router: Router, flag: number): void {
    debugger;
    const urlArray = ref(getUrlArrayFromSession());
    console.log(urlArray);
    if(flag == 1){
        window.location.reload();
        flag=0;
    }
    if(flag == 5){
        let lastUrl;
        lastUrl = findStoretabDetails(urlArray.value);
        const extractedPath = lastUrl.startsWith('/') ? lastUrl : extractPathFromUrl(lastUrl);
        const x = extractedPath.startsWith('#') ? extractedPath.slice(1) : extractedPath;
        router.push(x!);
        flag=0;
    }
    if (flag != 0) {
        
        if (urlArray.value.length > 0) {
            const  i = flag;
            const lastUrl = urlArray.value[urlArray.value.length - i];
    let spliced =  urlArray.value.splice(urlArray.value.length - i, urlArray.value.length -1);
            if (lastUrl) {
                const extractedPath = lastUrl.startsWith('/') ? lastUrl : extractPathFromUrl(lastUrl);
                const x = extractedPath.startsWith('#') ? extractedPath.slice(1) : extractedPath;
                router.push(x!);
            }
        }
    }
    else {
        const originalPushState = history.pushState;
        history.pushState = function (state: any, title: string, url?: string | null): void {
            debugger;
            if (urlArray.value.length === 0) {
                urlArray.value.push(window.location.href);
            }
            originalPushState.call(history, state, title, url);
            if (url && flag1.value === false) {
                const lastStoredUrl = urlArray.value[urlArray.value.length - 1];
                if(urlArray.value.indexOf(url) != -1){
                    urlArray.value.splice(urlArray.value.indexOf(url), 1);
                }
                if (lastStoredUrl !== url) {
                    urlArray.value.push(url);
                    setUrlArrayToSession(urlArray.value);
                }
            }
        };
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const router = useRouter();
    setupHistoryManagement(router, 0);
});
